import { Link } from "@tanstack/react-router";
import { useCurrentOrg } from "@/hooks/use-current-org";
import {
	loginInvitationCopy,
	publicJoinSignInSearch,
} from "@/lib/sign-in-redirect";

/**
 * The sidebar's signed-out affordance: one heading and one link.
 *
 * It used to render a grid of provider icons straight from `/api/auth-config`.
 * In the sidebar that read as a wall of unrelated logos (a provider the
 * workspace did not even offer, a Globe fallback for anything unknown), and it
 * duplicated a decision the login route already owns. The login route owns
 * provider dispatch, errors, and account-link recovery, so this only has to
 * get someone there.
 */
export function SidebarSignIn() {
	const { org, isPublic, isMember } = useCurrentOrg();
	const workspaceName = isPublic && !isMember ? org?.name : undefined;
	const search = publicJoinSignInSearch(workspaceName);
	const heading =
		loginInvitationCopy(workspaceName, undefined)?.title ?? "Sign in to Lobu";

	return (
		<nav
			aria-label="Sign in"
			className="shrink-0 space-y-2 border-t border-sidebar-border p-4"
		>
			<p className="text-sm font-medium">{heading}</p>
			<Link
				to="/auth/login"
				search={search}
				className="block rounded-sm text-xs text-muted-foreground underline underline-offset-4 hover:text-sidebar-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
			>
				Continue to sign in
			</Link>
		</nav>
	);
}
